import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)},
  { path: 'dashboard', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [authGuard] },
  { path: 'auth', loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)},
  { path: 'view', loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)},
  { path: 'quotation', loadChildren: () => import('./features/quotation/quotation.module').then(m => m.QuotationModule) ,canActivate: [authGuard]},
  { path: 'policy', loadChildren: () => import('./features/policy/policy.module').then(m => m.PolicyModule),canActivate: [authGuard]},
  { path: 'administration', loadChildren: () => import('./features/administration/administration.module').then(m => m.AdministrationModule), canActivate: [authGuard]},
  { path: 'error', loadChildren: () => import('./pages//error/error.module').then(m => m.ErrorModule)},
  
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
